export default __webpack_public_path__ + "static/media/wasteless-gen.1dfac58c.png";